<!--<ng-container *ngIf="useWC; then webComponents; else legacyComponents"></ng-container>-->
<!--<ng-template #webComponents>-->
<!--</ng-template>-->
<!--<ng-template #legacyComponents>-->
<lm-fileupload-soho
    class="field"
    [layoutObject]="layoutObject"
    [specFields]="specFields"
    [model]="model"
    [placeHolder]="placeHolder"
    [layoutInfo]="layoutInfo"
    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
    [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
    (fieldEvent)="onFieldEvent($event)"
></lm-fileupload-soho>
